const Sitemap = [
  {
    label: 'Home',
    link: '/home',
    alias: 'home'
  },
  {
    label: 'Hörproben',
    link: '/hoerproben',
    alias: 'hoerproben'
  },
  {
    label: 'Aktuelle Projekte',
    link: '/aktuelle-projekte',
    alias: 'aktuelle-projekte'
  },
  {
    label: 'Über mich',
    link: '/ueber-mich',
    alias: 'ueber-mich'
  },
  {
    label: 'Stimmen über mich',
    link: '/stimmen-ueber-mich',
    alias: 'stimmen-ueber-mich'
  },
  {
    label: 'Kontakt',
    link: '/kontakt',
    alias: 'kontakt'
  },
  // {
  //   label: 'Impressum & Datenschutz',
  //   link: '/impressum-datenschutz',
  //   alias: 'impressum-datenschutz'
  // }
];

export default Sitemap;